import fetchAPI from '../../fetchAPI';

export const callCreateCoreKnowledgeBase = async ({
  locationId,
  question,
  answer
}: {
  locationId: string;
  question: string;
  answer: string;
}): Promise<iResponse<any>> => {
  const response: iResponse<any> = await fetchAPI({
    method: 'POST',
    route: `knowledge/location/${locationId}/single`,
    data: { question, answer },
    isZazu: true
  });

  return response;
};

export default callCreateCoreKnowledgeBase;
